import { PropsWithChildren } from "react";
import { listContainer } from "./styles.css";

export const ItemsList = ({ children }: PropsWithChildren) => {
  return <div className={listContainer}>{children}</div>;
};
